import { EXPLORE_ROUTES } from "./exploreRoutes";
import { QUIZ_ROUTES } from "./quizzes/quizRoutes";
import React from "react";
import "./GamesPreviousYear.css";
import MultipleItemSlider from "../components/MultipleItemSlider";
import shareico from "../assets/images/sharee.png";
import { useNavigate } from "react-router-dom";
import { mapPreviousYearItem } from "../utils/dashboardContent";
import { getStoredUser } from "../utils/authStorage";

const sliderSettings = {
  dots: false,
  infinite: false, 
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  pauseOnHover: true,
  arrows: true,
  
  swipeToSlide: false,
  focusOnSelect: true,
  touchMove: true,
  touchThreshold: 15,

   responsive: [
    { breakpoint: 1920, settings: { slidesToShow: 3.9 } },
    { breakpoint: 1600, settings: { slidesToShow: 2.9 } },
    { breakpoint: 1400, settings: { slidesToShow: 3 } },
    { breakpoint: 1285, settings: { slidesToShow: 2 } },
    { breakpoint: 1199, settings: { slidesToShow: 4 } },
    { breakpoint: 991,  settings: { slidesToShow: 3 } },
    { breakpoint: 767,  settings: { slidesToShow: 2.2 } },
    { breakpoint: 576,  settings: { slidesToShow: 1.9 } },
    { breakpoint: 400,  settings: { slidesToShow: 1.2 } },
    { breakpoint: 390,  settings: { slidesToShow: 1.1 } },
  ],
};                                                                                            

const PaperCard = ({ paper, onPractice }) => {
  return (
    <article className="paper-card">
      <div className="paper-card__content">
        <div className="paper-card__header">
          <div className="paper-card__icon">
            <i className="fa-solid fa-shield-halved"></i>
          </div>

          <button

            type="button"
            className="paper-card__share"
            aria-label={`Share ${paper.title}`}
          >
            <img src={shareico} alt="" />
          </button>
        </div>

        <h3 className="paper-card__title">{paper.title}</h3>

        <div className="paper-card__details">
          <div className="paper-card__detail">
            <i className="fa-regular fa-clock"></i>
            <span>{paper.duration}</span>
          
          </div>

          <div className="paper-card__detail">
            <i className="fa-regular fa-file-lines"></i>
            <span>{paper.questions}</span>
          </div>

          <div className="paper-card__detail">
            <i className="fa-solid fa-award"></i>
            <span>{paper.marks}</span>
          </div>
        </div>

        <div className="paper-card__meta">
          <div className="paper-card__attempts">
            <div><i className="fa-solid fa-book-open"></i></div>
            <div>{paper.attempts} Attempts</div>
          </div>

          <span className="paper-card__languages">
            {paper.languages}
          </span>
        </div>
      </div>

      <div className="paper-card__footer">
        <p>Attempted By {paper.attempts} Aspirants</p>

        <button type="button" className="paper-card__button" onClick={() => onPractice(paper)}>
          Practice Now
        </button>
      </div>
    </article>
  );
};

const PreviousYearPapers = ({ papers = [], isLoading = false, error = "" }) => {
  const navigate = useNavigate();
  const storedUser = getStoredUser();
  const fallbackStateId = Number(
    storedUser?.state_id || storedUser?.stateId || storedUser?.user_state_id || 0
  );
  const fallbackStateName =
    storedUser?.state_name || storedUser?.stateName || storedUser?.user_state_name || "";
  const items = (Array.isArray(papers) ? papers : []).map(mapPreviousYearItem);

  const handlePracticePaper = (paper) => {
    navigate(QUIZ_ROUTES.start, {
      state: {
        selectedQuiz: {
          ...paper,
          quiz_id: Number(paper?.quizId || paper?.id || 0),
          quizId: Number(paper?.quizId || paper?.id || 0),
        },
        selectedState: fallbackStateId
          ? {
              state_id: fallbackStateId,
              state_name: fallbackStateName,
            }
          : undefined,
        state_id: fallbackStateId || undefined,
        stateName: fallbackStateName,
        category_id: 1,
        route_key: 3,
        selectedQuizOption: "PY Paper",
      },
    });
  };

  return (
    <section className="previous-paper-section">
      <div className="quick-action__header">
        <h2 className="quick-action__title">
          Previous Year Paper
        </h2>

        {!isLoading ? (
          <button
            type="button"
            className="quick-action__see-all"
            onClick={() => navigate(EXPLORE_ROUTES.exams)}
          >
            See All
          </button>
        ) : (
          <span className="dashboard-skeleton dashboard-skeleton--button" aria-hidden="true" />
        )}
      </div>

      {isLoading ? (
        <div className="dashboard-skeleton-grid dashboard-skeleton-grid--papers" aria-hidden="true">
          {Array.from({ length: 3 }).map((_, index) => (
            <div className="paper-card dashboard-skeleton-paper-card" key={index}>
              <div className="dashboard-skeleton-stack">
                <span className="dashboard-skeleton dashboard-skeleton--icon" />
                <span className="dashboard-skeleton dashboard-skeleton--line dashboard-skeleton--title" />
                <span className="dashboard-skeleton dashboard-skeleton--line dashboard-skeleton--text" />
                <span className="dashboard-skeleton dashboard-skeleton--line dashboard-skeleton--text-short" />
                <span className="dashboard-skeleton dashboard-skeleton--line" style={{ width: "100%", height: "48px", borderRadius: "12px" }} />
                <span className="dashboard-skeleton dashboard-skeleton--line dashboard-skeleton--button" style={{ width: "100%" }} />
              </div>
            </div>
          ))}
        </div>
      ) : null}
      {!isLoading && error ? <p className="quick-action__status quick-action__status--error">{error}</p> : null}
      {!isLoading && !error && !items.length ? (
        <p className="quick-action__status">No previous year papers available.</p>
      ) : null}

      {!isLoading && !error && items.length ? (
        <MultipleItemSlider
          items={items}
          settings={sliderSettings}
          className="previous-year-slider"
          renderItem={(paper) => (
            <PaperCard paper={paper} onPractice={handlePracticePaper} />
          )}
        />
      ) : null}
    </section>
  );
};

export default PreviousYearPapers;
